import { useMutation } from "urql";

import { CreateTenantDocument } from "../../../graphql/generated.ts";

export function useCreateTenant() {
  return useMutation(CreateTenantDocument);
}
